import { Injectable } from "@angular/core";
import { BfxBaseBlotterFilteringService } from "../../bfx-base-blotter/bfx-base-blotter-filtering.service";
import {
  ActiveUserProfilePromiseService,
  ClientPromiseLookupService,
  CcyPairPromiseLookupService,
  CurrencyPairGroupPromiseLookupService,
  TradeTableDefinitionFactory,
  ColumnFilterType,
  AlgoStrategyLookupService,
} from "shared/cubiq-services";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxColDef } from "shared/cubiq-services/model/TableDefinition";
import {
  QueryRuleImpl,
  RequestOrderType,
  AlgoStrategyImpl,
  OrderType,
  OrderDataImpl,
} from "shared/cubiq-model-multi-asset";
import { BfxSysConfigUtilService } from "shared/auth-services";

@Injectable()
export class BfxBlotterTradeFilterService extends BfxBaseBlotterFilteringService {
  /** Set of all tradable algo descriptions (desc used in Filter defns) */
  private tradableAlgoDescriptions: Set<string> = new Set();

  constructor(
    protected tableDefinitionFactory: TradeTableDefinitionFactory,
    protected activeUserService: ActiveUserProfilePromiseService,
    protected clientService: ClientPromiseLookupService,
    protected currencyPairService: CcyPairPromiseLookupService,
    protected currencyPairGroupService: CurrencyPairGroupPromiseLookupService,
    protected algoStrategyLookup: AlgoStrategyLookupService,
    protected sysConfigUtilService: BfxSysConfigUtilService,
  ) {
    super(
      tableDefinitionFactory,
      activeUserService,
      clientService,
      currencyPairService,
      currencyPairGroupService,
    );

    activeUserService.getActiveUserData().then((activeUser) => {
      activeUser.tradableAlgos.forEach((algoId) => {
        const algoStrategy: AlgoStrategyImpl = this.algoStrategyLookup.getAlgoStrategy(algoId);
        if (algoStrategy) {
          this.tradableAlgoDescriptions.add(algoStrategy.description);
        }
      });
    });
  }

  protected preprocessValues(column: BfxColDef, rule: QueryRuleImpl): Array<any> {
    let values: Array<any> = rule.values;

    switch (column.columnFilterType) {
      case ColumnFilterType.ORDERTYPE:
        const initValue: string[] = [];
        values = rule.values.reduce((result: string[], value: string) => {
          let val: any = RequestOrderType[value];
          if (val != null) {
            const orderStr = this.tableDefinitionFactory.myOrderTypeHelper.getValue(
              {
                [this.tableDefinitionFactory.myOrderTypeHelper.getColumnProperty()]: val,
              },
              false,
            );
            result.push(orderStr);
          } else {
            if (this.tradableAlgoDescriptions.has(value)) {
              result.push(value);
            }
          }
          return result;
        }, initValue);
        break;
      default:
        values = super.preprocessValues(column, rule);
        break;
    }
    return values;
  }
}
